import React from 'react'
import PropTypes from 'prop-types'
import Page from '@v4/components/common/Page'
import SectionList from '@v4/components/common/SectionList'
import PageTemplateData from '@v4/utils/data/PageTemplateData'

const Layout = ({ sectionsMap }) => {
	return (
		<Page>
			<SectionList collection={PageTemplateData.SORT_GROUPS.HEADER} sectionsMap={sectionsMap} />
			<SectionList collection={PageTemplateData.SORT_GROUPS.MAIN} sectionsMap={sectionsMap} />
			<SectionList collection={PageTemplateData.SORT_GROUPS.FOOTER} sectionsMap={sectionsMap} />
			<SectionList collection={PageTemplateData.SORT_GROUPS.POPUP} sectionsMap={sectionsMap} />
		</Page>
	)
}

Layout.propTypes = {
	sectionsMap: PropTypes.object.isRequired,
}

export default Layout
